import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import { setSelection, setSelectionType } from '../SpreadSheetDataProvider/actions'
import { selectionTypes } from '../helpers'
import BaseCell from './BaseCell'

ColHeaderCell = ({
  columnIndex,
  rowIndex,
  style
}) ->

  c = -1
  r = rowIndex

  [{
    isDragging,
    selection,
    selectionType
  }, dispatch] = useSpreadSheetData()

  selectSingleRow = ->
    dispatch(setSelectionType(selectionTypes.MULTI_ROW))
    dispatch(setSelection([r, r]))

  includeRowInSelection = ->
    dispatch(setSelection([selection[0], r]))

  <BaseCell
    rowIndex={r}
    colIndex={c}
    style={style}
    onMouseDown={(e) ->
      return if e.button is 2
      if e.shiftKey
        includeRowInSelection()
      else
        selectSingleRow()
    }
    onMouseMove={
      if isDragging and (selectionType is selectionTypes.MULTI_ROW)
        includeRowInSelection
    }
  >
    { rowIndex + 1 }
  </BaseCell>

export default React.memo(ColHeaderCell)